import { Outlet } from 'react-router-dom';

export default function CommissionLayout() {
    return <Outlet />;
}
